import { appEnvironmentSchema, createEnv, secretString, urlString } from '@hvac/config';
import { z } from 'zod';

/**
 * Web client configuration.
 *
 * Everything here is baked into the JavaScript bundle at build time and is
 * therefore **public**. Only values safe to hand to any visitor may appear.
 *
 * The Supabase anon key belongs to that category: it is designed to be public
 * and grants nothing on its own, because every table is protected by Row Level
 * Security. The service-role key must never appear in this file, in a `VITE_`
 * variable, or anywhere else in this app.
 */
const webEnvSchema = z.object({
  VITE_APP_ENV: appEnvironmentSchema.default('local'),
  VITE_API_BASE_URL: urlString('VITE_API_BASE_URL'),
  VITE_SUPABASE_URL: urlString('VITE_SUPABASE_URL'),
  VITE_SUPABASE_ANON_KEY: secretString('VITE_SUPABASE_ANON_KEY'),
  /** Error tracking. Public by design: a DSN only lets a browser send reports. */
  VITE_SENTRY_DSN: z.preprocess((value) => (value === '' ? undefined : value), z.url().optional()),
});

export type WebEnv = z.infer<typeof webEnvSchema>;

/**
 * Validated once at module load. A missing variable fails the first render with
 * a precise message rather than producing a blank screen and a 404 on an
 * `undefined` URL.
 */
export const env: Readonly<WebEnv> = createEnv({
  schema: webEnvSchema,
  source: import.meta.env,
  context: 'web client',
});
